import { tryLoadLightDOMStyles } from '@/components/webcomponents/Global/loadDependency'
import { getTemplateNavHeaderBasicStyles } from './NavHeader-Level0.styles'
import {
  ATTRIBUTES,
  CONTENT_WIDTH_VALUES,
  type ContentWidthValue,
} from '@/components/webcomponents/NavHeader/types/NavHeader.type'

const t = document.createElement('template')
t.innerHTML = `
<header class="ascend-header" role="banner">
  <nav class="main-nav" role="navigation" aria-label="Main Navigation">
    <!-- logo -->
    <slot name="logo"></slot>
    <!-- utility -->
    <slot name="utilityNavigation"></slot>
  </nav>
  <div class="tab-header">
    <slot name="primarySearchContainer"></slot> 
  </div>
</header>
`
const TemplateNavHeaderBasic = t

class NavHeaderBasic extends HTMLElement {
  static get observedAttributes() {
    return [ATTRIBUTES.HEADER_CONTENT_WIDTH, ATTRIBUTES.HIDE_LOGO]
  }

  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderBasicStyles().content.cloneNode(true))
    shadow.appendChild(TemplateNavHeaderBasic.content.cloneNode(true))
    tryLoadLightDOMStyles('NavHeader-Level0.css')
  }

  connectedCallback() {
    document.AscendAwesome?.LogManager?.logDebug('NavHeaderBasic connectedCallback: ', this)
    // Listen for search state changes from NavHeaderUtilitySearch
    this.addEventListener('search-state-changed', this.handleSearchStateChange as EventListener)
    this.addEventListener('search-icon-clicked', this.handleSearchIconClick as EventListener)

    if (document.querySelector('ts-nav-enterprise')) {
      this.setAttribute(ATTRIBUTES.HIDE_LOGO, '')
    }
  }

  disconnectedCallback() {
    this.removeEventListener('search-state-changed', this.handleSearchStateChange as EventListener)
    this.removeEventListener('search-icon-clicked', this.handleSearchIconClick as EventListener)
  }

  attributeChangedCallback(name: string, oldValue: string | null, newValue: string | null) {
    if (name === ATTRIBUTES.HEADER_CONTENT_WIDTH && oldValue !== newValue) {
      const validValues = Object.values(CONTENT_WIDTH_VALUES)
      if (newValue && !validValues.includes(newValue as ContentWidthValue)) {
        document.AscendAwesome?.LogManager?.logWarning(
          `NavHeaderBasic: Invalid value for ${ATTRIBUTES.HEADER_CONTENT_WIDTH}`,
        )
      }
    }
  }

  private handleSearchStateChange = (event: CustomEvent) => {
    const { visible } = event.detail
    const value = visible.toString()

    // Desktop / mobile search containers
    this.querySelectorAll('ts-navheader-search-container').forEach((el) =>
      el.setAttribute('search-visible', value),
    )

    // Utility search button
    this.querySelectorAll('ts-navheader-utility-search-button').forEach((el) =>
      el.setAttribute('search-visible', value),
    )

    // Utility search icon (button will auto-sync from this)
    this.querySelectorAll('ts-navheader-utility-search').forEach((el) =>
      el.setAttribute('search-visible', value),
    )
  }

  private handleSearchIconClick = (event: CustomEvent) => {
    // Optional: Handle search icon clicks for analytics, etc.
    console.log('Search icon clicked:', event.detail)
  }
}

if (!customElements.get('ts-navheader-level0')) {
  customElements.define('ts-navheader-level0', NavHeaderBasic)
}
export { NavHeaderBasic }
